const env = {
  apiBaseUrl: (import.meta.env.VITE_API_BASE_URL as string) ?? "/bff",
} as const;

export default env;
